import React from "react";

function ServiceNine() {
  return (
    <div>
      {/* awesome startupo service area start */}
      <div className="awesome-service-ten rts-section-gap" id="service">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="text-center title-area-ten">
                <h2 className="title">What We Do</h2>
              </div>
            </div>
          </div>
          <div className="row mt--20 g-5">
            <div className="col-lg-4 col-md-6 col-sm-12 col-12">
              {/* single inner service aarea */}
              <div className="single-inner-service-ten">
                <div className="icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="64"
                    height="64"
                    viewBox="0 0 64 64"
                    role="img"
                    aria-labelledby="analyticalSystemsTitle"
                  >
                    <title id="analyticalSystemsTitle">
                      Analytical Systems icon
                    </title>

                    <rect
                      x="6"
                      y="10"
                      width="32"
                      height="44"
                      rx="3"
                      ry="3"
                      fill="none"
                      stroke="#ef1414"
                      stroke-width="2.2"
                    />

                    <circle
                      cx="22"
                      cy="24"
                      r="6.2"
                      fill="none"
                      stroke="#ef1414"
                      stroke-width="2"
                    />
                    <path
                      d="M22 24 L24.8 21"
                      stroke="#ef1414"
                      stroke-width="1.8"
                      stroke-linecap="round"
                      fill="none"
                    />

                    <circle cx="14" cy="36" r="1.6" fill="#ef1414" />
                    <circle cx="22" cy="36" r="1.6" fill="#ef1414" />
                    <rect
                      x="10"
                      y="40"
                      width="22"
                      height="4"
                      rx="1"
                      fill="#ef1414"
                      opacity="0.12"
                    />

                    <path
                      d="M38 28 C42 28, 46 26, 50 26"
                      stroke="#ef1414"
                      stroke-width="2"
                      stroke-linecap="round"
                      fill="none"
                    />
                    <rect
                      x="50"
                      y="24.2"
                      width="8"
                      height="6"
                      rx="1"
                      fill="none"
                      stroke="#ef1414"
                      stroke-width="2"
                    />

                    <polyline
                      points="44,10 47,18 50,14 54,22 58,12"
                      fill="none"
                      stroke="#ef1414"
                      stroke-width="2"
                      stroke-linejoin="round"
                      stroke-linecap="round"
                    />

                    <line
                      x1="4"
                      y1="56"
                      x2="60"
                      y2="56"
                      stroke="#ef1414"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      opacity="0.25"
                    />
                  </svg>
                </div>
                <h5 className="title">Analytical Systems</h5>
                <p className="disc" style={{ textAlign: "justify" }}>
                  Sembian designs and fabricates a complete range of analyser
                  houses, shelters, cabinets, CEMS, SWAS and instrument racks
                  engineered to protect mission-critical analytical and control
                  equipment operating in harsh industrial environments.
                </p>
              </div>
              {/* single inner service aarea end */}
            </div>
            <div className="col-lg-4 col-md-6 col-sm-12 col-12">
              {/* single inner service aarea */}
              <div className="single-inner-service-ten">
                <div className="icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="64"
                    height="64"
                    viewBox="0 0 64 64"
                    role="img"
                    aria-labelledby="hydrogenTechTitle"
                  >
                    <title id="hydrogenTechTitle">
                      Hydrogen Technologies icon
                    </title>

                    <circle
                      cx="32"
                      cy="32"
                      r="22"
                      fill="none"
                      stroke="#ef1414"
                      stroke-width="2.5"
                    />

                    <text
                      x="50%"
                      y="50%"
                      text-anchor="middle"
                      dy="8"
                      font-size="18"
                      font-family="Arial, Helvetica, sans-serif"
                      fill="#ef1414"
                      font-weight="bold"
                    >
                      H₂
                    </text>

                    <path
                      d="M32 10 L32 4"
                      stroke="#ef1414"
                      stroke-width="2.2"
                      stroke-linecap="round"
                    />
                    <path
                      d="M48 16 L52 12"
                      stroke="#ef1414"
                      stroke-width="2.2"
                      stroke-linecap="round"
                    />
                    <path
                      d="M54 32 L60 32"
                      stroke="#ef1414"
                      stroke-width="2.2"
                      stroke-linecap="round"
                    />
                    <path
                      d="M48 48 L52 52"
                      stroke="#ef1414"
                      stroke-width="2.2"
                      stroke-linecap="round"
                    />
                    <path
                      d="M32 54 L32 60"
                      stroke="#ef1414"
                      stroke-width="2.2"
                      stroke-linecap="round"
                    />
                    <path
                      d="M16 48 L12 52"
                      stroke="#ef1414"
                      stroke-width="2.2"
                      stroke-linecap="round"
                    />
                    <path
                      d="M10 32 L4 32"
                      stroke="#ef1414"
                      stroke-width="2.2"
                      stroke-linecap="round"
                    />
                    <path
                      d="M16 16 L12 12"
                      stroke="#ef1414"
                      stroke-width="2.2"
                      stroke-linecap="round"
                    />
                  </svg>
                </div>
                <h5 className="title">Hydrogen Technologies</h5>
                <p className="disc" style={{ textAlign: "justify" }}>
                  Sembian designs and develops modular Proton Exchange Membrane
                  (PEM) electrolysers engineered for high efficiency,
                  compactness, and fast dynamic response. Our PEM stacks are
                  supported by an indigenously engineered Balance of Plant
                  (BoP).
                </p>
              </div>
              {/* single inner service aarea end */}
            </div>
            <div className="col-lg-4 col-md-6 col-sm-12 col-12">
              {/* single inner service aarea */}
              <div className="single-inner-service-ten">
                <div className="icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="64"
                    height="64"
                    viewBox="0 0 64 64"
                    role="img"
                    aria-labelledby="iesTitle"
                  >
                    <title id="iesTitle">
                      Industrial Engineering Solutions Icon
                    </title>

                    <g
                      fill="none"
                      stroke="#ef1414"
                      stroke-width="2.4"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    >
                      <circle cx="32" cy="32" r="12"></circle>

                      <path d="M32 16 L32 10" />
                      <path d="M45 19 L49 15" />
                      <path d="M48 32 L54 32" />
                      <path d="M45 45 L49 49" />
                      <path d="M32 48 L32 54" />
                      <path d="M19 45 L15 49" />
                      <path d="M16 32 L10 32" />
                      <path d="M19 19 L15 15" />

                      <circle cx="32" cy="32" r="5"></circle>

                      <line x1="32" y1="10" x2="32" y2="2"></line>
                      <circle cx="32" cy="2" r="2.2" fill="#ef1414" />

                      <line x1="54" y1="32" x2="62" y2="32"></line>
                      <circle cx="62" cy="32" r="2.2" fill="#ef1414" />

                      <line x1="32" y1="62" x2="32" y2="54"></line>
                      <circle cx="32" cy="62" r="2.2" fill="#ef1414" />

                      <line x1="2" y1="32" x2="10" y2="32"></line>
                      <circle cx="2" cy="32" r="2.2" fill="#ef1414" />
                    </g>
                  </svg>
                </div>
                <h5 className="title">Industrial Engineering Solutions</h5>
                <p className="disc" style={{ textAlign: "justify" }}>
                  HVAC, explosion-proof systems, fire & gas safety, industrial
                  steel doors, acoustic/fire-rated enclosures, SPM machines, and
                  precision-machined components.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ServiceNine;
